<template>
  <Authenticator class="m-5">
    <div class="my-2">
      <div class="my-3 pt-4">
        <h1 class="text-center mb-3">Requesting project</h1>
        <div class="row text-in-row my-2 py-2 mx-1">
          <div class="col-12">
            <div class="alert alert-light"
                  role="alert"
                  data-bs-theme="dark"
                  v-if="requesting_project && !error">
              <span>Requesting your project, please wait...</span>
            </div>
            <div class="alert alert-success"
                  role="alert"
                  data-bs-theme="dark"
                  v-if="!requesting_project">
              <span>Project requested successfully. I will reach out to you as soon as possible with a quotation via the email address associated with your account.</span>
            </div>
            <div class="alert alert-danger"
                  role="alert"
                  data-bs-theme="dark"
                  v-if="error">
              <span>Sorry, there was an requesting your project. Please reach out via the contact page with your project ID.</span>
            </div>
          </div>
          <span>
            For further questions, don't hesitate to reach out via the <a href="/contact">contact page</a>.
            Your project ID is: <strong>{{ $route.params.uuid }}</strong>.
          </span>
        </div>
      </div>
      <div class="d-flex justify-content-center align-items-center"
            v-if="requesting_project && !error">
        <div class="spinner-border m-2" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  </Authenticator>
</template>

<script>
  import { post_quotation } from '@/backend/backend.js'
  import Authenticator from '@/authenticator/authenticator.js'

  export default {
    components: {
      Authenticator,
    },
    data() {
      return {
        requesting_project: true,
        error: false,
      }
    },
    methods: {

    },
    created () {
      document.title = 'Request a project'
    },
    mounted () {
        const regex = /^[-a-zA-Z0-9]{36}$/;
        if (!regex.test(this.$route.params.uuid)) {return}

        post_quotation(this.$route.params.uuid)
          .then(response => {
            if (!response) {
              this.error = true;
              return;
            }

            if (response.message != 'Quotation sent') {
              this.error = true;
              return;
            }
  
            this.requesting_project = false;
          })
    }
  }
</script>

<style scoped>
  .text-in-row {
    text-align: left;
    background-color: rgb(43, 43, 43);
    border-radius: 10px;
  }
</style>
